import React from 'react';

const Booklet: React.FC<React.PropsWithChildren> = () => (
  <>
    <path d="M20.005 2C21.107 2 22 2.898 22 3.99V20.01C22 21.109 21.107 22 20.005 22H4V18H2V16H4V13H2V11H4V8H2V6H4V2H20.005ZM8 4H6V20H8V4ZM20 4H10V20H20V4Z" />
  </>
);

export default Booklet;
